import { Upload } from './Upload';
export const AcceptImages = ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml'];
export const uploadPicker = {
    name: 'Upload',
    icon: 'cloud-upload',
    component: Upload
};
